import router from '@/router/index';
import * as store from '../state/store'

let routes = [];
export const routingProcess = async () => {
  let isTokenThere = !!localStorage.getItem("token");
  if (isTokenThere) {
    routes = store.default.getters["routeAndMenu/getRoutes"];
    if (routes.length == 0) await store.default.dispatch('routeAndMenu/addRoutesAndMenuFromApi');
    await fillRoutesFromStore();
  }
};

const fillRoutesFromStore = async () => {
  routes.forEach(route => {
    router.addRoute(route);
  });
};